var _path, _path2, _circle, _circle2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrimary({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 40,
    viewBox: "0 0 88 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5436 27.6507L19.7125 23.7183C19.3341 23.33 19.3341 22.711 19.7125 22.3227L23.9987 17.9233C26.2624 11.8364 32.1248 7.5 39 7.5H72C80.8366 7.5 88 14.6634 88 23.5C88 32.3366 80.8366 39.5 72 39.5H39C31.599 39.5 25.3717 34.475 23.5436 27.6507Z",
    fill: "#FF5349",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.002 27.5H43.742V22.838H38.618V27.5H37.358V17.504H38.618V21.732H43.742V17.504H45.002V27.5ZM53.891 23.734C53.891 24.9753 53.5736 25.9367 52.939 26.618C52.3136 27.2993 51.4643 27.64 50.391 27.64C49.7283 27.64 49.1356 27.4907 48.613 27.192C48.0996 26.884 47.6936 26.4407 47.395 25.862C47.0963 25.274 46.947 24.5647 46.947 23.734C46.947 22.4927 47.2596 21.536 47.885 20.864C48.5103 20.192 49.3596 19.856 50.433 19.856C51.1143 19.856 51.7116 20.01 52.225 20.318C52.7476 20.6167 53.1536 21.0553 53.443 21.634C53.7416 22.2033 53.891 22.9033 53.891 23.734ZM48.221 23.734C48.221 24.6207 48.3936 25.3253 48.739 25.848C49.0936 26.3613 49.6536 26.618 50.419 26.618C51.175 26.618 51.7303 26.3613 52.085 25.848C52.4396 25.3253 52.617 24.6207 52.617 23.734C52.617 22.8473 52.4396 22.152 52.085 21.648C51.7303 21.144 51.1703 20.892 50.405 20.892C49.6396 20.892 49.0843 21.144 48.739 21.648C48.3936 22.152 48.221 22.8473 48.221 23.734ZM63.8755 19.856C64.7249 19.856 65.3595 20.0753 65.7795 20.514C66.1995 20.9433 66.4095 21.6433 66.4095 22.614V27.5H65.1915V22.67C65.1915 21.4847 64.6828 20.892 63.6655 20.892C62.9375 20.892 62.4148 21.102 62.0975 21.522C61.7895 21.942 61.6355 22.5533 61.6355 23.356V27.5H60.4175V22.67C60.4175 21.4847 59.9042 20.892 58.8775 20.892C58.1215 20.892 57.5988 21.1253 57.3095 21.592C57.0202 22.0587 56.8755 22.7307 56.8755 23.608V27.5H55.6435V19.996H56.6375L56.8195 21.018H56.8895C57.1228 20.626 57.4355 20.3367 57.8275 20.15C58.2288 19.954 58.6535 19.856 59.1015 19.856C60.2775 19.856 61.0428 20.276 61.3975 21.116H61.4675C61.7195 20.6867 62.0602 20.3693 62.4895 20.164C62.9282 19.9587 63.3902 19.856 63.8755 19.856ZM71.4255 19.856C72.0695 19.856 72.6202 19.996 73.0775 20.276C73.5442 20.556 73.8988 20.9527 74.1415 21.466C74.3935 21.97 74.5195 22.5627 74.5195 23.244V23.986H69.3815C69.4002 24.8353 69.6148 25.484 70.0255 25.932C70.4455 26.3707 71.0288 26.59 71.7755 26.59C72.2515 26.59 72.6715 26.548 73.0355 26.464C73.4088 26.3707 73.7915 26.24 74.1835 26.072V27.15C73.8008 27.318 73.4228 27.4393 73.0495 27.514C72.6762 27.598 72.2328 27.64 71.7195 27.64C71.0102 27.64 70.3802 27.4953 69.8295 27.206C69.2882 26.9167 68.8635 26.4873 68.5555 25.918C68.2568 25.3393 68.1075 24.6347 68.1075 23.804C68.1075 22.9827 68.2428 22.278 68.5135 21.69C68.7935 21.102 69.1808 20.6493 69.6755 20.332C70.1795 20.0147 70.7628 19.856 71.4255 19.856ZM71.4115 20.864C70.8235 20.864 70.3568 21.0553 70.0115 21.438C69.6755 21.8113 69.4748 22.334 69.4095 23.006H73.2315C73.2222 22.3713 73.0728 21.858 72.7835 21.466C72.4942 21.0647 72.0368 20.864 71.4115 20.864Z",
    fill: "#1A1515"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 12,
    cy: 23.5,
    r: 7,
    fill: "#FF5349"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 23.5,
    r: 4,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 10.25C19.5 17 12 22.25 12 22.25C12 22.25 4.5 17 4.5 10.25C4.5 8.26088 5.29018 6.35322 6.6967 4.9467C8.10322 3.54018 10.0109 2.75 12 2.75C13.9891 2.75 15.8968 3.54018 17.3033 4.9467C18.7098 6.35322 19.5 8.26088 19.5 10.25Z",
    fill: "#FF5B4D",
    stroke: "url(#paint0_linear_5803_21461)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.25C13.6569 13.25 15 11.9069 15 10.25C15 8.59315 13.6569 7.25 12 7.25C10.3431 7.25 9 8.59315 9 10.25C9 11.9069 10.3431 13.25 12 13.25Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5803_21461",
    x1: 11.4375,
    y1: -0.5,
    x2: 25.3343,
    y2: 15.6536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF765C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5349"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrimary);
export default __webpack_public_path__ + "static/media/primary.d706e695ec6e9d33f251b8ddc3ba2fce.svg";
export { ForwardRef as ReactComponent };